import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "../../Snackbar.jsx";
import { markers, mH, pM } from "../../lib/marker.js";
import { GET_MAP_DATA } from "../../GraphQL/Queries";
import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import "leaflet-fullscreen/dist/Leaflet.fullscreen.js";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import { useGeolocation } from "beautiful-react-hooks";

const useStyles = makeStyles(() => ({
  heading: {
    fontFamily: "Inter",
  },
}));

function LeafletMap() {
  const classes = useStyles();

  const { data } = useQuery(GET_MAP_DATA);
  const [stationen, setStationen] = useState([]);
  const [historicPoint, setHistoricPoint] = useState([]);
  const [geoLocation, setGeoLocation] = useState();
  const [snackbarContent, setSnackbarContent] = useState();
  const [geoState, { onChange }] = useGeolocation({
    enableHighAccuracy: true,
    maximumAge: 0,
  });

  onChange((position) => {
    setGeoLocation(position.coords);
  });

  useEffect(() => {
    if (data) {
      setStationen(data.stationCollection.items);
      setHistoricPoint(data.historicPointCollection.items);
    }
  }, [data]);

  return (
    <>
      <Snackbar snackbarContent={snackbarContent} setSnackbarContent={setSnackbarContent} />
      <MapContainer
        fullscreenControl={true}
        center={[49.356478, 9.1475]}
        zoom={14}
        zoomControl={true}
        scrollWheelZoom={true}
      >
        <TileLayer url="https://api.mapbox.com/styles/v1/maggis/ckk8c3rcm17th17lf2wcsrhnj/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibWFnZ2lzIiwiYSI6ImNrazhjMXh1ajA3Y2UycXM5Z2h4cHRlOTIifQ.idmPVdGiRlbmJ1JRmURkaQ" />
        {geoState.isSupported && geoState.position && geoLocation && (
          <Marker position={[geoLocation.latitude, geoLocation.longitude]} icon={pM}>
            <Popup>
              <p className={classes.heading}>
                <b>ICH</b>
              </p>
            </Popup>
          </Marker>
        )}
        {stationen.map((point, idx) => {
          return (
            <Marker
              position={[`${point.position.lat}`, `${point.position.lon}`]}
              icon={markers[idx]}
              key={idx}
            >
              <Popup>
                <p className={classes.heading}>
                  <b>
                    {point.stationsnummer}. {point.stationsname}
                  </b>
                  <br />
                  {point.uebungenCollection.items.map((ex, idx, array) => {
                    if (array.length > 1 && ex !== array[array.length - 1]) {
                      return `${ex.titel}, `;
                    }
                    return ex.titel;
                  })}
                </p>
              </Popup>
            </Marker>
          );
        })}
        {historicPoint.map((point, idx) => {
          return (
            <Marker
              position={[`${point.position.lat}`, `${point.position.lon}`]}
              icon={mH}
              key={idx}
            >
              <Popup>
                <p className={classes.heading}>
                  <b>{point.name}</b>
                </p>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </>
  );
}

export default LeafletMap;
